import React from 'react';
import { GlobalStyle } from '@withjoy/joykit';
import { RouterCreateWedding } from '@apps/acquisitionFunnels/createWedding/route.paths';
import { TelemetryProvider } from './CreateWedding.telemetry';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from '@shared/core';
import { CREATE_WEDDING_APP_NAME } from '@apps/acquisitionFunnels/createWedding/constants';
import { useSaveCurrentAcquisitionContext } from '@shared/createEvent/acquisitionContextTracking';
import { Seo } from '@shared/components/Seo';

const CreateWeddingApp = () => {
  const { t } = useTranslation('createWedding');
  useSaveCurrentAcquisitionContext();

  return (
    <>
      <Seo
        title={t('title')()}
        description={t('description')()}
      />
      <Helmet>
        <link
          rel="canonical"
          href="https://withjoy.com/createwedding"
        />
        <meta
          name="robots"
          content="noindex"
        />
      </Helmet>
      <TelemetryProvider>
        <GlobalStyle />
        <RouterCreateWedding appUrl={CREATE_WEDDING_APP_NAME} />
      </TelemetryProvider>
    </>
  );
};

export default CreateWeddingApp;
